import { useEffect, useState } from "react";
import { BASE_URL } from "../../constants/url";

// Facebook Lead Ads pages for the agency.
export default function useFacebook({ agencyId, token }) {
  const [pages, setPages] = useState([]);
  const [fbLoading, setFbLoading] = useState(true);
  const [disconnectingPageId, setDisconnectingPageId] = useState(null);

  // ─── Facebook: fetch pages ──────────────────────────────────
  useEffect(() => {
    if (!agencyId) return;
    fetch(`${BASE_URL}api/facebooknew/pages?agencyId=${agencyId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => setPages(data || []))
      .catch(() => setPages([]))
      .finally(() => setFbLoading(false));
  }, [agencyId, token]);

  const handleDisconnectPage = async (pageId) => {
    if (!agencyId || !pageId) return;
    setDisconnectingPageId(pageId);
    try {
      const res = await fetch(
        `${BASE_URL}api/facebooknew/deletefbpage?agencyId=${agencyId}&pageId=${pageId}`,
        { method: "POST", headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.ok) setPages((prev) => prev.filter((p) => p.PageId !== pageId));
    } catch {
      // silently ignore
    } finally {
      setDisconnectingPageId(null);
    }
  };

  const handleConnectFacebook = () => {
    window.location.href =
      `https://www.facebook.com/v23.0/dialog/oauth` +
      `?client_id=955470040527558` +
      `&redirect_uri=https://data.realtorscrm.com/api/facebooknew/callback` +
      `&state=${agencyId}` +
      `&response_type=code` +
      `&scope=pages_show_list,pages_read_engagement,leads_retrieval,business_management,pages_manage_metadata`;
  };

  const fbConnected = pages.length > 0;

  return {
    pages,
    fbLoading,
    fbConnected,
    disconnectingPageId,
    handleDisconnectPage,
    handleConnectFacebook,
  };
}
